import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

const ModalShell = ({ onClose, ariaLabel, ariaLabelledBy, className, scrimClassName, style, children }) => {
	const dialogRef = useRef(null);
	const lastFocused = useRef(null);

	useEffect(() => {
		lastFocused.current = document.activeElement;
		const node = dialogRef.current;
		const focusables = node ? node.querySelectorAll(FOCUSABLE) : [];
		if (focusables.length) focusables[0].focus();

		const onKey = (e) => {
			if (e.key === 'Escape') {
				e.stopPropagation();
				onClose();
				return;
			}
			if (e.key !== 'Tab') return;
			const list = node.querySelectorAll(FOCUSABLE);
			if (!list.length) return;
			const first = list[0];
			const last = list[list.length - 1];
			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault();
				last.focus();
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		};
		document.addEventListener('keydown', onKey);
		return () => {
			document.removeEventListener('keydown', onKey);
			if (lastFocused.current && lastFocused.current.focus) lastFocused.current.focus();
		};
	}, [onClose]);

	const portalNode = document.querySelector('#modal-portal') || document.body;

	return ReactDOM.createPortal(
		<div className={`image-upload-modal-scrim${scrimClassName ? ' ' + scrimClassName : ''}`} onMouseDown={onClose}>
			<div
				ref={dialogRef}
				className={`image-upload-modal${className ? ' ' + className : ''}`}
				style={style}
				role="dialog"
				aria-modal="true"
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
				onMouseDown={(e) => e.stopPropagation()}
			>
				{children}
			</div>
		</div>,
		portalNode
	);
};

export default ModalShell;
